<template>
  <md-field>
    <label>Valor</label>
    <md-input v-model="value" required type="number" @input="change" />
  </md-field>
</template>

<script>
export default {
  name: 'TermoValor',
  props: ['initialValue'],
  data() {
    return {
      value: 0,
    }
  },
  beforeMount() {
    if (this.initialValue) {
      this.value = this.initialValue
    }
  },
  methods: {
    change(e) {
      if (e !== '') {
        this.$emit('change', { value: e })
      }
    },
  },
}
</script>

<style scoped></style>
